import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AppTheme {
  name: string;
  displayName?: string;
  isDark?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  defaultTheme: AppTheme = {
    name: 'light',
    displayName: 'Light Theme',
    isDark: false,
  };

  darkTheme: AppTheme = {
    name: 'dark',
    displayName: 'Dark Theme',
    isDark: true,
  };

  themes: AppTheme[] = [this.defaultTheme, this.darkTheme];

  private themeSubject$ = new BehaviorSubject(this.defaultTheme);
  theme$ = this.themeSubject$.asObservable();

  setTheme(theme: AppTheme) {
    this.themeSubject$.next(theme);
  }

  findTheme(themeName: string): AppTheme | undefined {
    return this.themes.find(currentTheme => currentTheme.name === themeName);
  }
}
